module.exports = __webpack_public_path__ + "img/sticker_14.8dcd5c9a.svg";